<template>
  <div>
      <VueMultiselect
          v-model="selected"
          :options="options"
          :multiple=AllowMultiple
          :close-on-select=CloseOnSelect
          :placeholder="InputPlaceholder"
          label="label"
          track-by="label">
      </VueMultiselect>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
export default {
  props:{
      options: Array,
      OnChange: Function,
      InputPlaceholder: String,
      AllowMultiple: Boolean,
      CloseOnSelect: Boolean,
  },
  components: { VueMultiselect },
  data () {
    return {
      selected: [],
    }
  },
  watch:{
    selected(newValue){
      this.InvokeOnChange(newValue);
    }
  },
  methods:{
    InvokeOnChange(selectedItems)
    {
      if (this.OnChange !== null &&
          this.OnChange !== undefined)
      {
        this.OnChange(selectedItems);
      }
    },
    ToggleItem(labelName)
    {
      if (this.selected === null)
      {
        this.selected = [{label: labelName}];
        this.InvokeOnChange(this.selected);
        return;
      }

      for (let i = 0; i < this.selected.length; i++)
      {
        if (this.selected[i].label === labelName)
        {
          this.selected.splice(i, 1);
          this.InvokeOnChange(this.selected);
          return;
        }
      }

      this.selected.push({label: labelName});
      this.InvokeOnChange(this.selected);
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
.multiselect
{
    min-height: unset !important;
    height: 100%;
}

.multiselect__select
{
    height: 24px !important;
}

.multiselect__tags
{
    min-height: unset !important;
    padding: unset !important;
    border: unset !important;
    white-space: nowrap;
    overflow-x: hidden;
}

.multiselect__tag
{
    margin-bottom: unset !important;
}

.multiselect__placeholder
{
    margin-bottom: unset !important;
}
</style>